import React from 'react';

export const replaceStringWithJSX = (text: string, changes: {[key: string]: string | JSX.Element }) => {
  const splitText = text.split("%%");
  const keys = Object.keys(changes);

  const finalText = splitText.map((string, i) => {
    const key = `substr-${i}`;
     if (keys.includes(string) && React.isValidElement(changes[string])) {
      return React.cloneElement(changes[string] as JSX.Element, { key });
     } else {
      return <React.Fragment key={key}>{ string }</React.Fragment>;
     }
  });
  return finalText;
};
